import Vue from 'vue';
import VueHotkey from 'v-hotkey';
import VueNativeSock from 'vue-native-websocket';
import store from '@/store';
import miniToastr from 'mini-toastr';
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full';
import 'vue-select/dist/vue-select.css';
import '@/mixins/filters.js';

Vue.use(VueHotkey);
var host = location.host;
if (process.env.VUE_APP_BASE_URL != '/') {
  const url = new URL(process.env.VUE_APP_BASE_URL)
  host = url.host
}

Vue.use(VueNativeSock, (window.location.protocol=='https:'?'wss':'ws') + `://${host}/ingest/ws`, {
  connectManually: true,
  store: store,
  reconnection: true,
  reconnectionAttempts: 0,
  reconnectionDelay: 5000,
});

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);
Vue.component('vue-select', vSelect) // This overrides the normal name v-select, as this conflicts with vuetify

miniToastr.init()
